export default __webpack_public_path__ + "static/Blind-angels-rymsky-temica-video-thumbnail-0f1c31eca1285d86860346655e71aee3.jpg";